// extracted by mini-css-extract-plugin
export var body = "B_d";
export var help = "B_bT";
export var informer = "B_bQ";
export var informerSameSize = "B_bR";
export var postfix = "B_bS";
export var title = "B_s";